import { Button } from '@wartek-id/button'
import { Text } from '@wartek-id/text'

import Image from 'components/Image'
// max-w-[576px] is from main parent classNames
const BannerSurvey = () => {
  return (
    <section
      className="-ml-4 flex w-screen max-w-[576px] bg-interactive-hovered p-4"
      style={{
        backgroundImage: `url(/perangkat-ajar/images/search/banner-survey-background.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right bottom',
        backgroundSize: 'auto 100%',
      }}
    >
      <section className="flex-1">
        <Text variant="action" className="static flex gap-1 !text-blue-5">
          Berikan{' '}
          <div className="static">
            <Text variant="action" as="span" className="!text-blue-5">
              masukan
            </Text>{' '}
            <Image
              className="absolute -mt-1 -ml-1"
              src="/images/search/banner-survey-masukan-highlight.png"
              alt="Word Emphasis Image"
              width={70}
              height={8}
            />
          </div>
          agar
        </Text>
        <Text variant="action" className="!text-blue-5">
          Perangkat Ajar lebih baik lagi
        </Text>
        <Button
          color="white"
          size="sm"
          className="mt-2"
          onClick={() =>
            (window.location.href =
              'https://www.research.net/r/perangkatajar23')
          }
        >
          <Text variant="body-sm-bold" className="!text-informational">
            Klik &amp; Isi Survey
          </Text>
        </Button>
      </section>
      <section className="justify-self-end">
        <Image
          src="/images/search/banner-survey-tnc.svg"
          width={72}
          height={72}
          alt="TnC Logo of Banner Survey"
        />
      </section>
    </section>
  )
}

export default BannerSurvey
